import React from 'react';
import PropTypes from 'prop-types';
import { responsivePropType } from '../../utils/responsiveProp';

import type { ShortTextProps, ShortTextComponent } from './types';
import { StyledShortText } from './ShortText.styles';
import type { PolymorphicRef } from '../../utils/types';

function _ShortText<C extends 'p' | 'label' | 'span' | 'legend' = 'span'>(
  props: ShortTextProps<C>,
  ref?: PolymorphicRef<C>
) {
  const {
    children,
    size = 'default',
    color = 'default',
    weight = 'default',
    ...otherProps
  } = props;

  const commonProps = {
    size,
    color,
    weight,
    ...otherProps,
  };

  return (
    <StyledShortText {...commonProps} ref={ref}>
      {children}
    </StyledShortText>
  );
}

export const ShortText = React.forwardRef(_ShortText) as ShortTextComponent;

ShortText.propTypes = {
  size: responsivePropType(
    PropTypes.oneOf(['xsmall', 'small', 'default', 'large', 'xlarge'] as const)
  ),
  weight: PropTypes.oneOf(['default', 'strong']),
  truncated: PropTypes.bool,
  wordBreak: PropTypes.bool,
  color: PropTypes.string,
  italic: PropTypes.bool,
  textAlign: responsivePropType(PropTypes.oneOf(['left', 'center', 'right'] as const)),
};
